// Marketing attribution capture (UTM + landing page + referrer).
//
// Mirrors the affiliate `?ref=` pattern: capture on any page load, persist in
// localStorage (first-touch — the earliest source is kept), and attach to the
// signup + checkout requests. Everything here is best-effort and wrapped in
// try/catch so it can never break a page render or a request.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const EXTRA_KEYS = ['page', 'section', 'cta', 'gclid', 'fbclid']; // captured into raw if present
const STORE_KEY = 'openhosst_utm';

// Capture attribution from the current URL, once (first-touch wins).
export function captureAttribution() {
  if (typeof window === 'undefined') return;
  try {
    if (localStorage.getItem(STORE_KEY)) return; // already captured — keep earliest
    const params = new URLSearchParams(window.location.search);
    const rec = {};
    let has = false;
    [...UTM_KEYS, ...EXTRA_KEYS].forEach((k) => {
      const v = params.get(k);
      if (v) { rec[k] = v; has = true; }
    });
    if (!has) return; // nothing to record
    rec.landing_page = window.location.pathname || null;
    rec.referrer_url = document.referrer || null;
    rec.captured_at = new Date().toISOString();
    localStorage.setItem(STORE_KEY, JSON.stringify(rec));
  } catch (_) { /* non-fatal */ }
}

// Flat payload for API bodies. Returns {} when nothing was captured.
export function getStoredAttribution() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return {};
    const r = JSON.parse(raw);
    return {
      utm_source: r.utm_source || null,
      utm_medium: r.utm_medium || null,
      utm_campaign: r.utm_campaign || null,
      utm_term: r.utm_term || null,
      utm_content: r.utm_content || null,
      landing_page: r.landing_page || null,
      referrer_url: r.referrer_url || null,
      utm_raw: raw, // full JSON incl. any extras (page/section/cta/gclid/fbclid)
    };
  } catch (_) { return {}; }
}
